let accounting = require('accounting-js');

module.exports = class Utils {

    /**
     * Convertit une valeur monétaire textuelle en nombre
     * @param {string} value
     */
    static toNumber(value) {
        if (value === undefined || value === null) {
            return value;
        }
        let string = value.replace(/,/g, '.').replace(/\s/g,'').replace(/€/g,'');
        return parseFloat(string);
    }

    /**
     * Convertit une valeur monétaire textuelle en nombre
     * Renvoi 0 pour les valeurs non convertibles
     * @param {string} value
     */
    static toNumberOrDefault(value) {
        if(value == undefined || value == null){
            return 0;
        }
        
        let string = value.replace(/,/g, '.').replace(/\s/g,'').replace(/€/g,'');
        let number = parseFloat(string);
        if (isFinite(number)) {
            return number;
        }
        
        return 0;
    }

    /**
     * Convertit une valeur numerique en texte monétaire
     * @param {Number} value
     * @param {Number} precision
     * @param {boolean} withSymbol
     */
    static toCurrency(value, precision = 2, withSymbol = false) {
        let symbol = withSymbol ? "€" : "";
        let format = withSymbol ? "%v %s" : "%v";
        return accounting.formatMoney(value,  { symbol:symbol, precision:precision, thousand:" ", decimal:",", format: format});
    }

    /**
     * Remplace toutes les occurences d'un texte par un autre
     * @param {string} str le texte à traiter
     * @param {string} find le texte à remplacer
     * @param {string} replace le texte de remplacement
     * @return {string} le texte traité
     */
    static replaceAll(str, find, replace) {
        let escapeRegExp = find.replace(/[.*+\-?^${}()|[\]\\]/g, '\\$&'); // $& means the whole matched string
        return str.replace(new RegExp(escapeRegExp, 'g'), replace);
    }

    /** Arrondi un number à la précision demandée */
    static round(num, prec){
        var i=Math.pow(10,prec);
        return Math.round(num*i)/i;
    }

    /**
     * Crée un cookie
     * @param {*} cname nom du cookie
     * @param {*} cvalue valeur du cookie
     * @param {*} exdays expiration en jours
     */
     static setCookie(cname, cvalue, exdays) 
     {
         const d = new Date();
         d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
         let expires = "expires="+d.toUTCString();
         document.cookie = cname + "=" + JSON.stringify(cvalue) + ";" + expires + ";path=/";
     }
     
     /**
      * Charge un cookie
      * @param {*} cname nom du cookie
      * @returns {string} valeur du cookie
      */
     static getCookie(cname) 
     {
         let name = cname + "=";
         let ca = document.cookie.split(';');
         for(let i = 0; i < ca.length; i++) {
             let c = ca[i];
             while (c.charAt(0) == ' ') {
                 c = c.substring(1);
             }
             if (c.indexOf(name) == 0) {
                 return c.substring(name.length, c.length);
             }
         }
         return "";
     }

     /**
      * Retourne la différence en mois entre 2 dates.
      * @param {Date} date1 
      * @param {Date} date2 
      */
     static diffInMonths(date1, date2) 
     {
         let y1 = date1.getFullYear();
         let y2 = date2.getFullYear();
         let m1 = date1.getMonth();
         let m2 = date2.getMonth();
         if (m1 === 0) {
             m1++;
             m2++;
         }

         let numberofMonths = (y2 - y1) * 12 + (m2 - m1);

         return numberofMonths;
     }

     /**
     * Convertis un objet date en texte sql standard.
     * @param {*} date L'objet date à convertir. 
     * @returns {string} Le texte sql correspondant à la date
     */
    static dateToSql(date)
    {
        let dd = date.getDate();
        let mm = date.getMonth() + 1; //January is 0!
        let yyyy = date.getFullYear();
        if (dd < 10) {
          dd = '0' + dd;
        }
        if (mm < 10) {
          mm = '0' + mm;
        }
        return yyyy + '-' + mm + '-' + dd;
    }

    /**
     * Convertis un texte de date francais (dd/mm/YYYY) en texte sql standard (YYYY-mm-dd).
     * @param {string} date le texte de date eu format français
     * @returns {string} le texte de date au format sql
     */
    static dateFrToSql(date)
    {
        let dateFrParts = date.split('/');
        return dateFrParts[2] + '-' + dateFrParts[1] + '-' + dateFrParts[0];
    }

    static humanReadableSize(size, limit = 100, precision = 1)
    {
        let unites = ['o', 'Ko', 'Mo', 'Go', 'To', 'Po'];
        let unite = 0;
        while (size >= limit) {
            size = size / 1024;
            unite++;
        }
        let rounded = Utils.round(size, precision);
        let readable = Utils.toCurrency(rounded, precision);
        return readable + ' ' + unites[unite];
    }

    static dropzoneValidations = {
        'acceptedFilesDefault' : 'image/*, .doc, .docx, .pdf, .indd, .psd, .xls, .xlsx',
        'acceptedFilesImages' : 'image/*',
        'errorTextAcceptedDefault': 'Seules les extensions suivantes sont acceptées : jpeg,png,jpg,gif,bmp,svg,doc,docx,pdf,indd,psd,xls,xlsx,zip,rar',
        'errorTextAcceptedImages' : 'Seuls les formats image sont acceptés : jpeg,png,jpg,gif,bmp,svg'
    };
}
